import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Assets
import { CopyIcon } from 'assets/images/Icons'
// Views
import { Modal, ModalHeader, ModalBody } from 'views/components'
import CreateApiKeyForm from '../../Forms/AuthForms/CreateApiKeyForm'
import {
  ResultWrapper,
  ResultText,
  ResultCodeContainer,
  ResultContainer,
  ResultActionWrapper,
  ResultActionContainer,
  ColWrapper,
  CopyNotification,
} from './CreateApiKeyModal.elements'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function CreateApiKeyModal(props) {
  // Destructure
  const { ui, actions } = props

  // Store State
  const { isCreateApiKeyModalOpen } = ui

  // Store Actions
  const { toggleCreateApiKeyModal, setIsPageTableUpdated } = actions

  // Local State
  const [token, setToken] = useState()
  const [copyNotification, setCopyNotification] = useState('')

  // Functions
  const toggleModal = () => {
    toggleCreateApiKeyModal()
  }
  const handleExit = () => {
    setToken()
    setIsPageTableUpdated(true)
  }
  const copyHash = () => {
    navigator.clipboard.writeText(token).then(
      () => setCopyNotification('Copied!'),
      () => setCopyNotification('Error: Could not copy'),
    )
    setTimeout(() => setCopyNotification(''), 700)
  }

  // UseEffect
  useEffect(() => {
    if (!isCreateApiKeyModalOpen && token) handleExit()
  }, [isCreateApiKeyModalOpen])
  return (
    <Modal isOpen={isCreateApiKeyModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>{token ? 'Successfully generated API Key' : 'Store your API Key'}</ModalHeader>
      <ModalBody style={{ maxWidth: '600px', overflow: 'visible' }}>
        {!token && <CreateApiKeyForm setResponse={setToken} />}
        {token && (
          <ResultWrapper>
            <ColWrapper style={{ padding: '0 12px' }}>
              <ResultText>
                Please store your API key securely, as it will not be shown again. Anyone with access to this key can
                make requests on your behalf. If it is lost, you will need to generate a new one.
              </ResultText>
            </ColWrapper>
            <ResultCodeContainer>
              <ResultActionWrapper>
                <ResultActionContainer onClick={copyHash}>
                  <ResultText>Copy to Clipboard</ResultText>
                  <CopyIcon size={18} className="hashWrapper" />
                  <CopyNotification display={copyNotification}>{copyNotification}</CopyNotification>
                </ResultActionContainer>
              </ResultActionWrapper>
              <ResultContainer>
                <ResultText style={{ wordBreak: 'break-all', fontSize: 12 }}>{token}</ResultText>
              </ResultContainer>
            </ResultCodeContainer>
          </ResultWrapper>
        )}
      </ModalBody>
    </Modal>
  )
}

// Default Props
CreateApiKeyModal.defaultProps = {
  ui: {},
  form: {},
  actions: {},
}

// Proptypes Validation
CreateApiKeyModal.propTypes = {
  ui: PropTypes.shape({
    isCreateApiKeyModalOpen: PropTypes.bool,
    approveVaspDetails: PropTypes.shape({
      vasp_name: PropTypes.string,
      vasp_id: PropTypes.string,
    }),
  }),
  form: PropTypes.shape({
    activityToRemove: PropTypes.shape({
      type: PropTypes.string,
      hash: PropTypes.string,
    }),
  }),
  address: PropTypes.shape({
    addressRemove: PropTypes.shape({ address_id: PropTypes.string }),
  }),
  actions: PropTypes.shape({
    toggleCreateApiKeyModal: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setAddressRemove: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateApiKeyModal)
